import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

export type LoaderSize = "sm" | "md" | "lg";

interface LoaderProps {
  overlay?: boolean;
  size?: number;
  className?: string;
  center?: boolean;
}

export function Loader({
  overlay = false,
  size = 16,
  center = true,
  className,
}: LoaderProps) {
  const baseSpinner = (
    <Loader2
      className={cn("animate-spin text-primary-foreground", className)}
      size={size}
    />
  );

  if (overlay) {
    return (
      <div
        className={cn(
          "fixed inset-0 z-50 flex items-center justify-center",
          center && "w-full",
        )}
      >
        {baseSpinner}
      </div>
    );
  }

  return (
    <div
      className={cn(
        "inline-flex items-center justify-center",
        center && "w-full",
      )}
    >
      {baseSpinner}
    </div>
  );
}
